import { Link, useLocation } from "react-router-dom";
import { Home, Compass, BookOpen, Bookmark, Info } from "lucide-react";
import { BOTTOM_NAV } from "@/constants/testIds";

// Same 5 destinations as the desktop header, same order, cross-device parity.
const ITEMS = [
  { key: "home",          label: "الرئيسية",     href: "/",              Icon: Home,     testId: BOTTOM_NAV.home },
  { key: "opportunities", label: "الفرص",        href: "/opportunities", Icon: Compass,  testId: BOTTOM_NAV.opportunities, matchPrefix: "/opportunities" },
  { key: "knowledge",     label: "المعرفة",      href: "/knowledge",     Icon: BookOpen, testId: BOTTOM_NAV.knowledge,     matchPrefix: "/knowledge" },
  { key: "saved",         label: "المحفوظات",    href: "/saved",         Icon: Bookmark, testId: BOTTOM_NAV.saved },
  { key: "about",         label: "حول",          href: "/about",         Icon: Info,     testId: BOTTOM_NAV.about },
];

const isActive = (item, pathname) => {
  if (item.matchPrefix) return pathname === item.matchPrefix || pathname.startsWith(item.matchPrefix + "/");
  return pathname === item.href;
};

export const BottomNav = () => {
  const { pathname } = useLocation();

  // Hide entirely on the admin surface — admin has its own navigation shell.
  if (pathname.startsWith("/admin")) return null;

  return (
    <nav
      data-testid={BOTTOM_NAV.root}
      aria-label="التنقل السفلي"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white/95 backdrop-blur-sm md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="mx-auto flex max-w-md items-stretch justify-around">
        {ITEMS.map((item) => {
          const active = isActive(item, pathname);
          const Icon = item.Icon;
          return (
            <li key={item.key} className="flex-1">
              <Link
                to={item.href}
                data-testid={item.testId}
                aria-current={active ? "page" : undefined}
                className={`group flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                  active ? "text-gray-900" : "text-gray-500 hover:text-gray-900"
                }`}
              >
                <span
                  className={`inline-flex h-8 w-8 items-center justify-center rounded-lg transition-colors ${
                    active
                      ? "bg-intel-800 text-white"
                      : "bg-transparent text-ink-500 group-hover:bg-surface-100"
                  }`}
                >
                  <Icon className="h-4 w-4" strokeWidth={1.75} />
                </span>
                <span>{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
